// Record ids (Implementation Plan v02 §6.2, IR-26): random UUID v4, never
// time-ordered, so an id reveals nothing about when a record was written.

const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

export function newId(): string {
  return crypto.randomUUID()
}

export function isRecordId(value: unknown): value is string {
  return typeof value === 'string' && UUID_V4.test(value)
}
